import { techxeedGlassChromeListingToolbarClassName } from "@/lib/techxeed-glass-chrome";

/** Same 0.5px token borders as {@link techxeedGlassChromeClassName} / ThemeToggle (no full glass fill). */
const filterSheetControlBorder =
	"border-solid border-[0.5px] border-[color:var(--color-border-standard)] dark:border-[0.5px] dark:border-[color:var(--glass-border)]";

/**
 * Filter sheet controls: no fill; token borders + white type (matches theme toggle line treatment).
 */
export const filterSheetGlassCheckboxClassName = [
	"filter-sheet-glass-checkbox",
	"border-solid border-[0.5px] border-white",
	"bg-transparent text-white shadow-none backdrop-blur-xl ring-0 ring-offset-0 focus-visible:ring-offset-0",
	"data-[state=checked]:border-white",
	"data-[state=checked]:bg-brand-primary data-[state=checked]:text-white data-[state=checked]:backdrop-blur-none data-[state=checked]:shadow-sm data-[state=checked]:ring-0 data-[state=checked]:[&_svg]:text-white data-[state=checked]:[&_svg]:stroke-white",
].join(" ");

export const filterSheetGlassInputClassName = [
	"border-solid border-[0.5px] !border-white",
	"bg-transparent text-white caret-white shadow-none backdrop-blur-xl ring-0 placeholder:text-white/65 dark:text-white dark:placeholder:text-white/60",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent",
].join(" ");

/** Section titles inside the glass filter sheet */
export const filterSheetHeadingClassName = "text-base font-medium text-white sm:text-lg";

/** Row labels (categories, sectors, sort options, etc.) */
export const filterSheetRowLabelClassName = "text-sm2 text-white lg:text-base";

/** Sort radios: token border; focus ring matches theme chrome */
export const filterSheetGlassRadioItemClassName = [
	filterSheetControlBorder,
	"bg-transparent text-white shadow-none backdrop-blur-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-border-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-background",
	"[&_svg]:!fill-white",
].join(" ");

/**
 * Listing toolbar “Filters” pill — glass chrome like ThemeToggle, without hover/default shadow.
 */
export const listingFiltersGlassPillClassName = [
	techxeedGlassChromeListingToolbarClassName,
	"h-10 shrink-0 rounded-full px-4 text-xs font-normal text-foreground sm:px-5 sm:text-sm",
].join(" ");

/** Lucide icons in listing toolbar pills (search / filters / sort). */
export const listingToolbarLucideIconClassName =
	"listing-toolbar-lucide-icon size-4 shrink-0 text-[color:var(--color-brand-primary)] transition-colors duration-200";

/** Icon-only glass circle for Filters / Sort (click opens sheet or dropdown). */
export const listingToolbarIconCircleClassName = [
	techxeedGlassChromeListingToolbarClassName,
	"inline-flex size-10 shrink-0 items-center justify-center rounded-full !p-0",
	"hover:[&_svg]:text-[color:var(--color-brand-secondary)] dark:hover:[&_svg]:text-[color:var(--color-brand-secondary)]",
].join(" ");

/** Sort trigger: same glass circle as Filters; SelectTrigger base styles overridden. */
export const listingFiltersGlassSortIconTriggerClassName = [
	listingToolbarIconCircleClassName,
	"!flex !size-10 !min-w-10 !max-w-10 !justify-center !rounded-full !border-solid !border-[0.5px] !border-[color:var(--color-border-standard)] !bg-[var(--glass-background)] !p-0 !shadow-none ring-0 focus:ring-0 focus-visible:ring-2 focus-visible:ring-[color:var(--color-border-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-background",
	"dark:!border-[color:var(--glass-border)] dark:!bg-[var(--glass-background)] dark:hover:!bg-[rgba(11,21,27,0.78)]",
	"hover:!border-[color:var(--color-border-visible)] hover:!bg-white/50",
	"[&>span]:sr-only [&>span]:!m-0 [&>span]:!flex-none [&>span]:!p-0",
	"[&>svg:last-child]:hidden",
].join(" ");

/**
 * Listing “Sort by” trigger when `glassToolbar` (legacy full pill — non-expandable contexts).
 */
export const listingFiltersGlassSortTriggerClassName = [
	techxeedGlassChromeListingToolbarClassName,
	/* Shrink to label + chevron (avoid w-full + flex-1 gap); cap width for long sort labels. */
	"inline-flex h-10 w-max max-w-[min(100%,15.5rem)] min-w-0 shrink-0 items-center justify-start gap-2 rounded-full px-2.5 text-left text-xs font-normal sm:max-w-[min(100%,17rem)] sm:px-3 sm:text-sm",
	/* Label + chevron inherit trigger color so hover:text-* applies (avoid [&>span]:text-foreground — it blocked hover green). */
	"text-foreground transition-colors duration-200 dark:text-white",
	"hover:text-[color:var(--color-brand-secondary)] dark:hover:text-[color:var(--color-brand-secondary)]",
	"[&>span]:!block [&>span]:!flex-none [&>span]:min-w-0 [&>span]:max-w-[12.5rem] [&>span]:truncate [&>span]:text-left sm:[&>span]:max-w-[14rem]",
	"[&_svg]:shrink-0 [&_svg]:text-[color:var(--color-brand-primary)] [&_svg]:transition-colors [&_svg]:duration-200",
	"hover:[&_svg]:text-[color:var(--color-brand-secondary)] dark:hover:[&_svg]:text-[color:var(--color-brand-secondary)]",
].join(" ");
